'use client'

import React from 'react'

export function SmoothLink(
  props: React.AnchorHTMLAttributes<HTMLAnchorElement> & { targetId: string },
) {
  const { targetId, href, onClick, ...rest } = props
  return (
    <a
      href={href ?? `#${targetId}`}
      onClick={(e) => {
        e.preventDefault()
        const el = document.getElementById(targetId)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
          history.replaceState(null, '', `#${targetId}`)
        }
        onClick?.(e)
      }}
      {...rest}
    />
  )
}
